import * as React from 'react'
import { observer } from 'mobx-react'
import { useBrandingSettings } from 'hooks/branding'
import DeleteJobViewModel from './DeleteJobViewModel'
import ErrorBlock from 'components/ErrorBlock'
import {
  Dialog,
  DialogButton,
  DialogButtonGroup,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogIllustration,
  DialogTitle,
} from 'components/Dialog'

interface DeleteJobDialogProps {
  vm: DeleteJobViewModel
}

/**
 * The DeleteJobDialog
 */
export default observer(function DeleteJobDialog({ vm }: DeleteJobDialogProps) {
  const { corporateMode } = useBrandingSettings()
  return (
    <Dialog showing={vm.showing} onClose={vm.close}>
      <DialogHeader>
        {!corporateMode && (
          <DialogIllustration
            src={require('assets/images/img_forfeit-job.svg')}
            alt="Illustration of man tossing a crumbled piece of paper"
          />
        )}
        <DialogTitle>Are you sure you want to delete?</DialogTitle>
        <DialogDescription>
          This action cannot be undone. Are you sure you want to delete this
          draft?
        </DialogDescription>
      </DialogHeader>
      {vm.performDelete.rejected && (
        <ErrorBlock
          tackOn="bottom"
          error={vm.performDelete.error}
          onCloseClick={() => vm.performDelete.reset()}
        />
      )}
      <DialogFooter bordered>
        <DialogButtonGroup>
          <DialogButton disabled={vm.performDelete.pending} onClick={vm.close}>
            Cancel
          </DialogButton>
          <DialogButton
            onClick={vm.performDelete}
            disabled={vm.performDelete.pending}
            loading={vm.performDelete.pending}
            type="danger"
          >
            Delete
          </DialogButton>
        </DialogButtonGroup>
      </DialogFooter>
    </Dialog>
  )
})
